import React from 'react';
import { motion } from 'framer-motion';
import { useReveal, useBentoGlow } from '../hooks/useScrollReveal';
import '../styles/Experience.css';

const fadeUp = { hidden: { opacity: 0, y: 30 }, visible: { opacity: 1, y: 0 } };

const Experience = () => {
    const [ref, isVisible] = useReveal();
    const glowRef = useBentoGlow();

    const experiences = [
        { id: 'e1', period: 'Present', title: 'UPN Veteran Jawa Timur', subtitle: 'Informatics Engineering', description: 'Currently pursuing degree in Informatics Engineering. Active in campus organizations and developing full-stack skills.', icon: '/upn.webp', type: 'education' },
        { id: 'e2', period: '2025/2026', title: 'Advokesma Himatifa', subtitle: 'UPN Veteran Jawa Timur', description: 'Active member of the informatics student association, participating in organizational activities and advocacy.', icon: '/himatifa.webp', type: 'organization' },
        { id: 'e3', period: 'Present', title: 'MikroTik Certified', subtitle: 'Network Routing & Switching', description: 'Possess MikroTik certification demonstrating practical knowledge in networking infrastructure and configuration.', icon: '/laxo.webp', type: 'experience' },
        { id: 'e4', period: 'Recent', title: 'Hackathon & WIA Competitions', subtitle: 'Tech Competitions', description: 'Active track record in competitive programming and tech solutions, participating in WIA, Hackathons, and achieving Semi Final in INJECTION ITS.', icons: ['/WIA.webp', '/IYREF.webp'], type: 'achievement' },
    ];

    const typeColors = {
        education: 'var(--accent)',
        organization: '#9370DB',
        experience: 'var(--success)',
        achievement: 'var(--warning)',
    };

    return (
        <section id="experience" className="experience" ref={ref}>
            <div className="container" ref={glowRef}>
                {isVisible && (
                    <motion.div
                        className="experience-grid"
                        initial="hidden"
                        animate="visible"
                        variants={{ visible: { transition: { staggerChildren: 0.1, delayChildren: 0.1 } } }}
                    >
                        {/* Header Cell */}
                        <motion.div className="bento-card section-header-card exp-header" variants={fadeUp}>
                            <span className="section-label">Journey</span>
                            <h2 className="section-heading">
                                Experience & <br /><span className="gradient-text">Timeline</span>
                            </h2>
                            <p className="section-desc">
                                My educational and professional milestones.
                            </p>
                        </motion.div>

                        {/* Experience Cards */}
                        {experiences.map((exp) => (
                            <motion.div
                                key={exp.id}
                                className={`bento-card exp-card ${exp.id}`}
                                variants={fadeUp}
                                transition={{ duration: 0.5 }}
                                whileHover={{ y: -4, transition: { duration: 0.2 } }}
                                style={{ '--stripe-color': typeColors[exp.type] }}
                            >
                                <div className="exp-stripe" />
                                <div className="exp-top">
                                    <span className="mono" style={{ fontSize: '0.75rem', color: 'var(--text-tertiary)' }}>
                                        {exp.period}
                                    </span>
                                    <span className="exp-badge" data-type={exp.type}>{exp.type}</span>
                                </div>
                                <div className="exp-content">
                                    <div className="exp-text-heavy">
                                        <h3 className="massive-exp-title">{exp.title}</h3>
                                        <p className="exp-sub">{exp.subtitle}</p>
                                        <p className="exp-desc">{exp.description}</p>
                                    </div>
                                    <div className="exp-icon-abs" style={{ display: 'flex', gap: '12px', width: 'auto' }}>
                                        {exp.icons ? (
                                            exp.icons.map((ico, idx) => (
                                                <img key={idx} src={ico} alt={`${exp.title} ${idx}`} style={{ width: '54px', height: '54px', objectFit: 'contain' }} onError={(e) => { e.target.style.display = 'none'; }} />
                                            ))
                                        ) : (
                                            <img src={exp.icon} alt={exp.title} style={{ width: '54px', height: '54px', objectFit: 'contain' }} onError={(e) => { e.target.style.display = 'none'; }} />
                                        )}
                                    </div>
                                </div>
                            </motion.div>
                        ))}
                    </motion.div>
                )}
            </div>
        </section>
    );
};

export default Experience;